import {
    CONSULTAR_PARAMETROS,
    PARAMETROS_CONSULTADOS,
    ERROR_CONSULTANDO_PARAMETROS,
    GESTIONAR_PARAMETRO,
    GESTION_EXITO,
    GESTION_ERROR,
    LIMPIAR_MENSAJES_PARAMETROS,
    VENTANA_AYUDA_PARAMETRO,
    parametrosConsultados,
    errorConsultandoParametros,
    gestionExito,
    gestionError
} from "./adminParametroActions";
import { AnyAction } from "redux";
import { authenticatedAjax, REQUEST } from "../../../../config/ajax-wrapper";
import { FiltroAdminParametros } from "../modelo/AdminParametro";
import { errorAutorizacion } from "../../../../inicio/modulos/inicioActions";
import { SolicitudAdminParametro, Parametro } from "../modelo/AdminParametro";

export const consultarParametrosEpic = action$ =>
    action$.ofType(CONSULTAR_PARAMETROS)
        .mergeMap((action: any) => {

            const url = `sat/consultar/parametros?${obtenerFiltroParametros(action.filtro)}`;

            return authenticatedAjax
                .get(
                    url
                )
                .map((response) => {
                    const respuesta = JSON.parse(response.response);
                    return parametrosConsultados(respuesta.datosEntidad, respuesta.paginas, respuesta.totalDatos);
                })
                .catch(response => {
                    if (response.status === 401 || response.status === 403) {
                        return [errorAutorizacion(response.response, response.status)];
                    }
                    return [errorConsultandoParametros()];
                });
        });

export const gestionarParametroEpic = action$ =>
    action$.ofType(GESTIONAR_PARAMETRO)
        .mergeMap((action: any) => {

            const url = `sat/administrar/parametro`;

            return authenticatedAjax
                .post(
                    url,
                    action.solicitud,
                    { 'Content-Type': 'application/json' }
                )
                .map((response) => {
                    return gestionExito();
                }).catch(response => {
                    const respuesta = response.response;
                    const mensajeRespuesta = (respuesta && respuesta.mensajeRespuesta) ? respuesta.mensajeRespuesta : "Error no controlado en la aplicación";
                    return [gestionError(mensajeRespuesta)];
                });

        });

export const parametrosReducer = (state = {
    estado: REQUEST.NONE,
    estadoAccion: REQUEST.NONE,
    mensajeAccion: undefined,
    showAlert: false,
    parametros: [],
    paginas: 0,
    totalParametrosConsulta: 0,
    tamanoPagina: 10,
    paginaActual: 0,
    ventanaAyudaParametro: undefined
}, action: AnyAction) => {
    switch (action.type) {

        case CONSULTAR_PARAMETROS:
            return {
                ...state,
                estado: REQUEST.PENDING,
                parametros: [],
                paginas: 0,
                tamanoPagina: action.filtro.tamanoPagina,
                totalParametrosConsulta: 0,
                paginaActual: action.filtro.paginaActual,
                showAlert: false
            };
        case PARAMETROS_CONSULTADOS:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                parametros: action.datosEntidad,
                paginas: action.paginas,
                totalParametrosConsulta: action.totalDatos,
                showAlert: false
            };
        case ERROR_CONSULTANDO_PARAMETROS:
            return {
                ...state,
                estado: REQUEST.ERROR,
                parametros: [],
                paginas: 0,
                totalParametrosConsulta: 0,
                showAlert: false
            };
        case GESTIONAR_PARAMETRO:
            return {
                ...state,
                estado: REQUEST.PENDING,
                parametros: parametroEnGestion(action.solicitud, state.parametros),
                showAlert: false
            };
        case GESTION_EXITO:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.SUCCESS,
                showAlert: true
            };
        case GESTION_ERROR:
            return {
                ...state,
                estado: REQUEST.SUCCESS,
                estadoAccion: REQUEST.ERROR,
                mensajeAccion: action.mensaje,
                showAlert: true
            };
        case LIMPIAR_MENSAJES_PARAMETROS:
            return {
                ...state,
                estado: REQUEST.NONE,
                estadoAccion: REQUEST.NONE,
                mensajeAccion: undefined,
                showAlert: false,
                parametros: [],
                paginas: 0,
                totalParametrosConsulta: 0,
                tamanoPagina: 10,
                paginaActual: 0
            };
        case VENTANA_AYUDA_PARAMETRO:
            return{
                ...state,
                ventanaAyudaParametro: true
            };
        default:
            return state;
    }
};

const obtenerFiltroParametros = (filtro: FiltroAdminParametros) => {
    let params = new URLSearchParams();
    if (filtro) {

        if (filtro.codigo) params.set('codigo', filtro.codigo);
        if (filtro.valor) params.set('palabraClave', filtro.valor);
        if (filtro.fecha && filtro.complementoFecha) {
            params.set('fecha', filtro.fecha);
            params.set('complementoFecha', filtro.complementoFecha.toString());
        }
        if (filtro.paginaActual) params.set('pagina', (filtro.paginaActual + 1).toString());
        else params.set('pagina', '1');
        if (filtro.tamanoPagina) params.set('registrosPorPagina', filtro.tamanoPagina.toString());
        else params.set('registrosPorPagina', '10');

    }

    return params.toString();
};

const parametroEnGestion = (solicitud: SolicitudAdminParametro, parametros: Array<Parametro>) => {
    return parametros.map(parametro => {
        if (parametro.codigo === solicitud.datos.codigo) {
            parametro.pendiente = true;
        }
        return parametro;
    });
};


// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_parametros/modulos/adminParametroReducers.ts